export class Localities {
  constructor(localities) {
    this.localities = localities;
  }
  getLocalities() {
    return this.localities;
  }
}